import React from 'react';
import uploadIcon from './assets/upload.svg';

interface DragAndDropZoneProps {
    onDrop: (e: React.DragEvent) => void;
    onDragOver: (e: React.DragEvent) => void;
    onDragLeave: (e: React.DragEvent) => void;
    onFileInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isDragOver: boolean;
    accept: string;
    showMaxSize?: boolean;
}

const DragAndDropZone: React.FC<DragAndDropZoneProps> = ({
    onDrop,
    onDragOver,
    onDragLeave,
    onFileInputChange,
    isDragOver,
    accept,
    showMaxSize = true
}) => {
    return (
        <div
            className={`bg-white border border-dashed rounded-xl text-center transition-colors relative w-full ${
                isDragOver ? 'border-blue-400 bg-blue-50' : 'border-gray-200 hover:border-gray-300'
            }`}
            onDrop={onDrop}
            onDragOver={onDragOver}
            onDragLeave={onDragLeave}
        >
            <div className="flex flex-col items-center justify-center px-12 py-6 gap-5">
                <div className="w-[70px] h-[45px]">
                    <img src={uploadIcon} alt="upload" className="w-full h-full" />
                </div>

                <div className="flex flex-col gap-1 items-center">
                    <div className="flex items-center gap-[5px]">
                        <span className="text-base font-medium text-gray-800">
                            Drag and drop files here
                        </span>
                        <label className="text-sm font-bold text-[#3773a8] cursor-pointer hover:underline">
                            Upload
                            <input
                                type="file"
                                multiple
                                accept={accept}
                                className="hidden"
                                onChange={onFileInputChange}
                            />
                        </label>
                    </div>
                    {showMaxSize && (
                        <p className="text-sm text-gray-400 font-medium">Maximum size: 50MB</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DragAndDropZone;
